import { makeAutoObservable } from 'mobx';
import { z } from 'zod';
import { StringDto } from '../../../../../../store/utils/Dto';
import extractValue, {
  type EventOrValue,
} from '../../../../../../store/utils/extractValue';
import Validator from '../../../../../../store/utils/Validator';
import { errorHandler } from '../../../../../../utils/errors';

export default class PulseVersion {
  static readonly Schema = z.object({
    enabled: z.boolean(),
    minPulseClientVersion: z.string(),
  });

  enabled = true;
  minPulseClientVersion = '';

  private readonly validator = new Validator(this, PulseVersion.Schema);

  constructor(
    dto: string | undefined,
    private readonly onSave: (pulseVersion: PulseVersion) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });

    this.enabled = Boolean(dto);
    this.minPulseClientVersion = dto || '';
  }

  get errors(): StringDto<PulseVersionForm> {
    return this.validator.errorsForEnabledFields;
  }

  handleChange(e: EventOrValue<keyof PulseVersionForm>) {
    const { name, value } = extractValue(e);
    Object.assign(this, { [name]: value });
    this.validator.validate();
    this.save();
  }

  handleBlur(e: EventOrValue<keyof PulseVersionForm>) {
    const { name } = extractValue(e);
    this.validator.enableFieldValidation(name);
  }

  save() {
    this.onSave(this).catch(
      errorHandler('Cannot save minimal Pulse Client Version'),
    );
  }

  toJSON(): string | undefined {
    if (!this.enabled || !this.minPulseClientVersion) {
      return undefined;
    }

    return this.minPulseClientVersion;
  }
}

interface PulseVersionForm {
  enabled: boolean;
  minPulseClientVersion: string;
}
